import FullWidthSection from "./section/FullWidthSection";

import logo from "@images/logo-full.png";
import AccentureLogo from "@svgs/accenture-logo.svg";
import SVGImage from "./SVGImage";
import Image from "./Image";
import {Link} from "gatsby-link";


const HeaderAccenture = () => (
	<FullWidthSection>
		<div className="text-center d-flex flex-column pt-7 pt-md-9 pb-7 align-items-center">
			<Link to="/">
				<Image src={logo} width={200} height={49} alt="Stay Nimble" className="d-inline-block mb-md-4"/>
			</Link>
			<span className="d-flex align-items-end flex-nowrap">
				<span style={{lineHeight: 1, top: 3}} className="d-block mr-1 position-relative">In partnership with </span>
			<SVGImage>
				<AccentureLogo/>
			</SVGImage>
			</span>
		</div>
	</FullWidthSection>
);

export default HeaderAccenture;
